export default [
    ['align', 'content'],
    ['align', 'items'],
    ['alignment', 'adjust'],
    ['alignment', 'baseline'],
    ['align', 'self'],
    ['animation', 'delay'],
    ['animation', 'direction'],
    ['animation', 'iteration', 'count'],
    ['animation', 'name'],
    ['animation', 'play', 'state'],
    ['appearance'],
    ['backface', 'visibility'],
    ['background'],
    ['background', 'attachment'],
    ['background', 'blend', 'mode'],
    ['background', 'color'],
    ['background', 'composite'],
    ['background', 'image'],
    ['background', 'origin'],
    ['background', 'position'],
    ['background', 'repeat'],
    ['baseline', 'shift'],
    ['behavior'],
    ['border'],
    ['border', 'bottom'],
    ['border', 'bottom', 'color'],
    ['border', 'bottom', 'left', 'radius'],
    ['border', 'bottom', 'right', 'radius'],
    ['border', 'bottom', 'style'],
    ['border', 'bottom', 'width'],
    ['border', 'collapse'],
    ['border', 'color'],
    ['border', 'corner', 'shape'],
    ['border', 'image', 'source'],
    ['border', 'image', 'width'],
    ['border', 'left'],
    ['border', 'left', 'color'],
    ['border', 'left', 'style'],
    ['border', 'left', 'width'],
    ['border', 'radius'],
    ['border', 'right'],
    ['border', 'right', 'color'],
    ['border', 'right', 'style'],
    ['border', 'right', 'width'],
    ['border', 'spacing'],
    ['border', 'style'],
    ['border', 'top'],
    ['border', 'top', 'color'],
    ['border', 'top', 'left', 'radius'],
    ['border', 'top', 'right', 'radius'],
    ['border', 'top', 'style'],
    ['border', 'top', 'width'],
    ['border', 'width'],
    ['bottom'],
    ['box', 'align'],
    ['box', 'decoration', 'break'],
    ['box', 'direction'],
    ['box', 'flex'],
    ['box', 'flex', 'group'],
    ['box', 'line', 'progression'],
    ['box', 'lines'],
    ['box', 'ordinal', 'group'],
    ['box', 'shadow'],
    ['break', 'after'],
    ['break', 'before'],
    ['break', 'inside'],
    ['clear'],
    ['clip'],
    ['clip', 'rule'],
    ['color'],
    ['column', 'count'],
    ['column', 'fill'],
    ['column', 'gap'],
    ['column', 'rule'],
    ['column', 'rule', 'color'],
    ['column', 'rule', 'width'],
    ['columns'],
    ['column', 'span'],
    ['column', 'width'],
    ['counter', 'increment'],
    ['counter', 'reset'],
    ['cue'],
    ['cue', 'after'],
    ['cursor'],
    ['direction'],
    ['display'],
    ['fill'],
    ['fill', 'opacity'],
    ['fill', 'rule'],
    ['filter'],
    ['flex'],
    ['flex', 'align'],
    ['flex', 'basis'],
    ['flex', 'direction'],
    ['flex', 'flow'],
    ['flex', 'grow'],
    ['flex', 'item', 'align'],
    ['flex', 'line', 'pack'],
    ['flex', 'order'],
    ['flex', 'shrink'],
    ['flex', 'wrap'],
    ['float'],
    ['flow', 'from'],
    ['font'],
    ['font', 'family'],
    ['font', 'kerning'],
    ['font', 'size'],
    ['font', 'size', 'adjust'],
    ['font', 'stretch'],
    ['font', 'style'],
    ['font', 'synthesis'],
    ['font', 'variant'],
    ['font', 'variant', 'alternates'],
    ['font', 'weight'],
    ['grid', 'area'],
    ['grid', 'column'],
    ['grid', 'column', 'end'],
    ['grid', 'column', 'start'],
    ['grid', 'row'],
    ['grid', 'row', 'end'],
    ['grid', 'row', 'position'],
    ['grid', 'row', 'span'],
    ['grid', 'template', 'areas'],
    ['grid', 'template', 'columns'],
    ['grid', 'template', 'rows'],
    ['height'],
    ['hyphenate', 'limit', 'chars'],
    ['hyphenate', 'limit', 'lines'],
    ['hyphenate', 'limit', 'zone'],
    ['hyphens'],
    ['ime', 'mode'],
    ['justify', 'content'],
    ['layout', 'grid'],
    ['layout', 'grid', 'char'],
    ['layout', 'grid', 'line'],
    ['layout', 'grid', 'mode'],
    ['layout', 'grid', 'type'],
    ['left'],
    ['letter', 'spacing'],
    ['line', 'break'],
    ['line', 'clamp'],
    ['line', 'height'],
    ['list', 'style'],
    ['list', 'style', 'image'],
    ['list', 'style', 'position'],
    ['list', 'style', 'type'],
    ['margin'],
    ['margin', 'bottom'],
    ['margin', 'left'],
    ['margin', 'right'],
    ['margin', 'top'],
    ['marquee', 'direction'],
    ['marquee', 'style'],
    ['mask'],
    ['mask', 'border'],
    ['mask', 'border', 'repeat'],
    ['mask', 'border', 'slice'],
    ['mask', 'border', 'source'],
    ['mask', 'border', 'width'],
    ['mask', 'clip'],
    ['mask', 'origin'],
    ['max', 'font', 'size'],
    ['max', 'height'],
    ['max', 'width'],
    ['min', 'height'],
    ['min', 'width'],
    ['opacity'],
    ['order'],
    ['orphans'],
    ['outline'],
    ['outline', 'color'],
    ['outline', 'offset'],
    ['overflow'],
    ['overflow', 'style'],
    ['overflow', 'x'],
    ['overflow', 'y'],
    ['padding'],
    ['padding', 'bottom'],
    ['padding', 'left'],
    ['padding', 'right'],
    ['padding', 'top'],
    ['page', 'break', 'after'],
    ['page', 'break', 'before'],
    ['page', 'break', 'inside'],
    ['pause'],
    ['pause', 'after'],
    ['pause', 'before'],
    ['perspective'],
    ['perspective', 'origin'],
    ['pointer', 'events'],
    ['position'],
    ['punctuation', 'trim'],
    ['quotes'],
    ['region', 'fragment'],
    ['rest', 'after'],
    ['rest', 'before'],
    ['right'],
    ['ruby', 'align'],
    ['ruby', 'position'],
    ['shape', 'image', 'threshold'],
    ['shape', 'inside'],
    ['shape', 'margin'],
    ['shape', 'outside'],
    ['speak'],
    ['speak', 'as'],
    ['stroke', 'opacity'],
    ['stroke', 'width'],
    ['table', 'layout'],
    ['tab', 'size'],
    ['text', 'align'],
    ['text', 'align', 'last'],
    ['text', 'decoration'],
    ['text', 'decoration', 'color'],
    ['text', 'decoration', 'line'],
    ['text', 'decoration', 'line', 'through'],
    ['text', 'decoration', 'none'],
    ['text', 'decoration', 'overline'],
    ['text', 'decoration', 'skip'],
    ['text', 'decoration', 'style'],
    ['text', 'decoration', 'underline'],
    ['text', 'emphasis'],
    ['text', 'emphasis', 'color'],
    ['text', 'emphasis', 'style'],
    ['text', 'height'],
    ['text', 'indent'],
    ['text', 'justify', 'trim'],
    ['text', 'kashida', 'space'],
    ['text', 'line', 'through'],
    ['text', 'line', 'through', 'color'],
    ['text', 'line', 'through', 'mode'],
    ['text', 'line', 'through', 'style'],
    ['text', 'line', 'through', 'width'],
    ['text', 'overflow'],
    ['text', 'overline'],
    ['text', 'overline', 'color'],
    ['text', 'overline', 'mode'],
    ['text', 'overline', 'style'],
    ['text', 'overline', 'width'],
    ['text', 'rendering'],
    ['text', 'script'],
    ['text', 'shadow'],
    ['text', 'transform'],
    ['text', 'underline', 'position'],
    ['text', 'underline', 'style'],
    ['top'],
    ['touch', 'action'],
    ['transform'],
    ['transform', 'origin'],
    ['transform', 'origin', 'z'],
    ['transform', 'style'],
    ['transition'],
    ['transition', 'delay'],
    ['transition', 'duration'],
    ['transition', 'property'],
    ['transition', 'timing', 'function'],
    ['unicode', 'bidi'],
    ['unicode', 'range'],
    ['user', 'focus'],
    ['user', 'input'],
    ['vertical', 'align'],
    ['visibility'],
    ['voice', 'balance'],
    ['voice', 'duration'],
    ['voice', 'family'],
    ['voice', 'pitch'],
    ['voice', 'range'],
    ['voice', 'rate'],
    ['voice', 'stress'],
    ['voice', 'volume'],
    ['white', 'space'],
    ['white', 'space', 'treatment'],
    ['widows'],
    ['width'],
    ['word', 'break'],
    ['word', 'spacing'],
    ['word', 'wrap'],
    ['wrap', 'flow'],
    ['wrap', 'margin'],
    ['wrap', 'option'],
    ['writing', 'mode'],
    ['z', 'index'],
    ['zoom']
];
